import React, { useState } from 'react';
import Dialog2, { Dialog2Header } from '@src/components/dialog2';
import SelectPaymentType from '../selectPaymentType';
import SinglePaymentLinkForm from '../singlePaymentLinkForm';
import RecurrentPaymentLinkForm from '../recurrentPaymentLinkForm';
import ArrowBackOutline from '@sendsprint/ui-react/dist/icons/ArrowBackOutline';

import '../../assets/paymentlinks.css';

interface Props {
  handleClose: () => void;
  isOpen: boolean;
  variant?: 'raas' | 'receiver';
}

type PaymentCurrentStepType = 'select-payment-type' | 'single-payment' | 'recurring-payment';

const PaymentLinkItems = ({ handleClose, isOpen, variant }: Props) => {
  const [currentStep, setCurrentStep] = useState<PaymentCurrentStepType>('select-payment-type');
  const [selectedItemId, setSelectedItemId] = useState<string | null>(null);

  const handleAddOpen = () => {
    if (selectedItemId === '1') {
      handleCurrentStep('single-payment');
      return;
    }
    if (selectedItemId === '2') {
      handleCurrentStep('recurring-payment');
      return;
    }
  };

  const handleCurrentStep = (arg: PaymentCurrentStepType) => {
    setCurrentStep(arg);
  };

  const handleSelectItemId = (arg: string) => {
    setSelectedItemId(arg);
  };

  return (
    <Dialog2 handleClose={handleClose} isOpen={isOpen} disableOverlayClick>
      <Dialog2Header
        handleClose={handleClose}
        label={
          <div className="ss-flex ss-items-center ss-gap-2">
            {currentStep !== 'select-payment-type' && (
              <button
                type="button"
                onClick={() => handleCurrentStep('select-payment-type')}
                className="focus:ss-focus-ring">
                <ArrowBackOutline />
              </button>
            )}
            <span>Create new payment link</span>
          </div>
        }
      />
      {currentStep === 'select-payment-type' && (
        <SelectPaymentType
          handleAddOpen={handleAddOpen}
          handleSelectItemId={handleSelectItemId}
          selectedItemId={selectedItemId}
        />
      )}
      {currentStep === 'single-payment' && (
        <SinglePaymentLinkForm handleClose={handleClose} isOpen variant={variant} />
      )}
      {currentStep === 'recurring-payment' && (
        <RecurrentPaymentLinkForm
          handleClose={handleClose}
          isOpen
          frequency={parseInt(selectedItemId ?? '0')}
          variant={variant}
        />
      )}
    </Dialog2>
  );
};

export default PaymentLinkItems;
